import {Blesk} from '@blesk-frontend/ui';
import {Link, Outlet} from '@tanstack/react-router';

export const AuthLayout = () => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-bg-secondary-hover p-4">
      <div className="translate-x-0 cursor-pointer lg:absolute lg:top-14 lg:left-14">
        <Link to="/">
          <Blesk />
        </Link>
      </div>
      <div className="mx-auto w-full max-w-lg">
        <Outlet />
      </div>
    </div>
  );
};
